import { render, staticRenderFns } from "./ReplenishmentRuleTable.vue?vue&type=template&id=2b105a58"
import script from "./ReplenishmentRuleTable.vue?vue&type=script&lang=js"
export * from "./ReplenishmentRuleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports